import { PageProps } from './types';

export const Page = ({ children, testId }: PageProps) => (
    <div id="main-content" className="relative min-h-dvh bg-page flex flex-col z-0" data-testid={testId}>
        {children}
    </div>
);
